// IMPORTANT:
// When packaging, because this is a copy of PageWrapper.tsx with a few modifications,
// please make sure this component is in-sync with PageWrapper.tsx

import { useLayoutEffect } from "react";

const PackageBuilderWrapper = (props: any) => {
  useLayoutEffect(() => {
    // this will force the header to not be sticky
    const navContainer = document.querySelector(
      ".nav-container"
    ) as HTMLDivElement;
    if (navContainer) {
      navContainer.classList.add("make-relative");
    }
  }, []);

  return <div className="jdc-container">{props.children}</div>;
};

export default PackageBuilderWrapper;
